
// ----->


import './img';

//piggybank

$( ('li.cubex img') ).click(function() {
  var lastClass = $('#screen').attr('class').split(' ').pop();
  console.log(lastClass)
  $('#screen').removeClass(lastClass).addClass(this.id);
});


// background music

  var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  if (!isChrome){
      $('#iframeAudio').remove()
  }
  else {
      $('#playAudio').remove() // just to make sure that it will not have 2x audio in the background 
  }
